import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_main = _resolveComponent("v-main")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_PasswordChangeDialog = _resolveComponent("PasswordChangeDialog")!
  const _component_DuckMount = _resolveComponent("DuckMount")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (!_ctx.routerReady)
        ? (_openBlock(), _createBlock(_component_v_main, { key: 0 }))
        : (_ctx.isLoginRoute)
          ? (_openBlock(), _createBlock(_component_v_main, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_v_app_bar, {
                style: {"background-color":"#ffffff","border-bottom":"1px solid var(--c-border)"},
                elevation: "0"
              }, {
                default: _withCtx(() => [
                  (_ctx.auth.isDeveloper && _ctx.problems.open > 0)
                    ? (_openBlock(), _createBlock(_component_v_badge, {
                        key: 0,
                        content: _ctx.problems.open,
                        color: "error",
                        "offset-x": "6",
                        "offset-y": "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_app_bar_nav_icon, {
                            "data-guide": "nav-menu",
                            style: {"color":"var(--c-text)"},
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawerOpen = !_ctx.drawerOpen))
                          })
                        ]),
                        _: 1
                      }, 8, ["content"]))
                    : (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                        key: 1,
                        "data-guide": "nav-menu",
                        style: {"color":"var(--c-text)"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drawerOpen = !_ctx.drawerOpen))
                      })),
                  _cache[8] || (_cache[8] = _createElementVNode("div", {
                    class: "d-flex flex-column justify-center",
                    style: {"line-height":"1.1"}
                  }, [
                    _createElementVNode("span", { style: {"color":"var(--c-brand)","font-weight":"700","font-size":"18px"} }, "Common Sense"),
                    _createElementVNode("span", { style: {"color":"var(--c-muted)","font-size":"11px"} }, "deur Linde Design (Pty) Ltd")
                  ], -1)),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_menu, null, {
                    activator: _withCtx(({ props }) => [
                      (_ctx.auth.logoUrl)
                        ? (_openBlock(), _createElementBlock("img", _mergeProps({ key: 0 }, props, {
                            "data-guide": "user-menu",
                            src: _ctx.auth.logoUrl,
                            alt: _ctx.auth.brokerageName || 'Logo',
                            class: "mr-3",
                            style: {"height":"36px","max-width":"120px","object-fit":"contain","cursor":"pointer"}
                          }), null, 16, _hoisted_1))
                        : (_openBlock(), _createElementBlock("img", _mergeProps({ key: 1 }, props, {
                            "data-guide": "user-menu",
                            src: _ctx.logo,
                            alt: "Common Sense",
                            class: "mr-3",
                            style: {"height":"36px","width":"36px","object-fit":"contain","cursor":"pointer"}
                          }), null, 16, _hoisted_2))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, {
                        density: "comfortable",
                        nav: ""
                      }, {
                        default: _withCtx(() => [
                          (_ctx.auth.firstName)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                title: `Hallo, ${_ctx.auth.firstName}`,
                                class: "text-caption",
                                style: {"color":"var(--c-muted)"},
                                disabled: ""
                              }, null, 8, ["title"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_divider, { class: "my-1" }),
                          (_ctx.auth.brokerageCount > 1)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                title: "Wissel makelaar",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('/kies-makelaar')))
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.auth.isAdmin)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 2,
                                title: "Gebruikers",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('/gebruikers')))
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.auth.isAdmin)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 3,
                                title: "Instellings",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigate('/instellings')))
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.auth.isAdmin && _ctx.auth.billingEnabled)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 4,
                                title: "Intekening",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigate('/abonnement')))
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, {
                            title: "Verander wagwoord",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.auth.passwordDialogOpen = true))
                          }),
                          _createVNode(_component_v_list_item, {
                            title: "Teken uit",
                            onClick: _ctx.logout
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_navigation_drawer, {
                modelValue: _ctx.drawerOpen,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.drawerOpen) = $event)),
                temporary: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    density: "comfortable",
                    nav: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: link.to,
                          "data-guide": link.guide,
                          title: link.label,
                          onClick: ($event: any) => (_ctx.navigate(link.to))
                        }, null, 8, ["data-guide", "title", "onClick"]))
                      }), 128)),
                      _createVNode(_component_v_list_group, { value: "nakoming" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps(props, { title: "Nakoming" }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.complianceLinks, (link) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: link.to,
                              title: link.label,
                              onClick: ($event: any) => (_ctx.navigate(link.to))
                            }, null, 8, ["title", "onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      (_ctx.auth.isDeveloper)
                        ? (_openBlock(), _createBlock(_component_v_list_group, {
                            key: 0,
                            value: "ontwikkelaar"
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps(props, { title: "Ontwikkelaar" }), {
                                append: _withCtx(() => [
                                  (_ctx.problems.open > 0)
                                    ? (_openBlock(), _createBlock(_component_v_badge, {
                                        key: 0,
                                        content: _ctx.problems.open,
                                        color: "error",
                                        inline: ""
                                      }, null, 8, ["content"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.developerLinks.filter((l) => !l.billing || _ctx.auth.billingEnabled), (link) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: link.to,
                                  title: link.label,
                                  onClick: ($event: any) => (_ctx.navigate(link.to))
                                }, _createSlots({ _: 2 }, [
                                  (link.to === '/skedule-probleme' && _ctx.problems.open > 0)
                                    ? {
                                        name: "append",
                                        fn: _withCtx(() => [
                                          _createVNode(_component_v_badge, {
                                            content: _ctx.problems.open,
                                            color: "error",
                                            inline: ""
                                          }, null, 8, ["content"])
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032, ["title", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_main, null, {
                default: _withCtx(() => [
                  _createVNode(_component_PasswordChangeDialog),
                  _createVNode(_component_router_view)
                ]),
                _: 1
              }),
              _createVNode(_component_DuckMount)
            ], 64))
    ]),
    _: 1
  }))
}